import { Box, Typography, Chip } from "@mui/material";
import { useTeamContext } from "@/Common/Contex/TeamContext";
import moment from "moment";
import { convertDuration } from "../../../utils/helper";
import { useNavigate } from "react-router-dom";
import PageRoutes from "@/utils/constants";

const LatestCondensedGames = () => {
  const { latestCondensedGame }: any = useTeamContext();
  const navigate = useNavigate();
  return (
    <Box>
      {latestCondensedGame && (
        <Box
          sx={{
            py: 2,
            px: 1,
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            onClick={() =>
              navigate(
                PageRoutes.ShortView.replace(":id", latestCondensedGame.ID)
              )
            }
          >
            <Box sx={{ position: "relative", overflow: "hidden" }}>
              <Box
                component={"img"}
                sx={{
                  height: 240,
                  width: 1,
                  objectFit: "cover",
                  transition: "transform 0.3s ease-in-out",

                  "&:hover": {
                    transform: "scale(1.03)",
                    cursor: "pointer",
                  },
                }}
                loading="lazy"
                src={latestCondensedGame?.Thumbnail}
                alt={
                  latestCondensedGame?.gameSummary?.Title ||
                  latestCondensedGame?.Title
                }
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 8,
                  left: 8,
                  right: 8,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box sx={{ display: "flex", gap: 0.5, flex: 1 }}>
                    {latestCondensedGame?.createdAt &&
                      !moment(latestCondensedGame?.createdAt).isBefore(
                        moment().subtract(4, "days")
                      ) && (
                        <Chip
                          sx={{ borderRadius: "4px" }}
                          label={"New"}
                          color="primary"
                          size="small"
                        />
                      )}
                  </Box>
                  <Chip
                    sx={{ mr: 2 }}
                    label={convertDuration(latestCondensedGame?.Duration)}
                    color="primary"
                    size="small"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontWeight: "600" }} variant="h6">
              {latestCondensedGame?.gameSummary?.Title ||
                latestCondensedGame?.Title}
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontWeight: 600 }}
            >
              {latestCondensedGame?.gameSummary?.PostGameShortSummary ||
                latestCondensedGame?.Description}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default LatestCondensedGames;
